'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

var tslib_es6 = require('../../../node_modules/tslib/tslib.es6.js');
var React = require('react');
var Provider = require('./components/Provider.js');
var Slider = require('./components/Slider.js');
var Swiper$1 = require('./Swiper.js');
var types = require('./types.js');
require('./Swiper.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Swiper = /** @class */ (function (_super) {
    tslib_es6.__extends(Swiper, _super);
    function Swiper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Swiper.prototype.render = function () {
        return (React__default['default'].createElement(Swiper$1.Swiper, tslib_es6.__assign({}, this.props)));
    };
    Swiper.Provider = Provider.Provider;
    Swiper.Slider = Slider.Slider;
    Swiper.SwiperTypes = types;
    return Swiper;
}(React.Component));

module.exports = Swiper;
//# sourceMappingURL=index.js.map
